module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEqSURBVEhL7ZI7SgNRFIbHXkhhXoULCJLGJaQypMs+sgIbCyVlxD2kCXZC7N2CeRWprERjpaDdTL5z5yfkYTP33k4/+LmPc+Y7MDPJP1mWHaVpekfeyQOpqBQHhG2GbOD8HHUIsmuJb02u/b3K4SB7lLRLBtq/qBwGogr5MOk23PXV4o/kEwlXZExuSEst/iCpkqnkExL1o5p8Jvk0try2J6+qFI7kc8lnQXIcJQTnOtq5viWfk5pKxeHhU7KU7FJ3vehyg/0rOVHNhtRdow8I7B3vyFkaVmMtu6YQEI6cWXBu2z3bhg0jV67RFwRfuTqH8xm5MLmu7K6p9uLw8Lc8v0J9wXKs9uIgWOWqQyT3/8AGkqdct0sUuYGoY0PIG/khn2RI3G/6V0mSNaqV/Ek3cIikAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-spade/light/24.png
// module id = 2456
// module chunks = 2